import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-210" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-bold leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-211" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-212" data-mp="mzq2r12kvz56">
        <span className="h-1 w-10 rounded-full bg-aqua/40" data-id="element-213" data-mp="i7oiosz6544l" />
        <span className="h-1 w-3 rounded-full bg-gold" data-id="element-214" data-mp="i652f2diit2t" />
      </span>
    </div>;
}